/** Command palette (Ctrl K) open state, shared by the shell and the assistant. */
import { useSyncExternalStore } from 'react';

let state = { open: false, query: '' };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((fn) => fn());

export function openSearch(query = ''): void {
  state = { open: true, query };
  emit();
}

export function closeSearch(): void {
  state = { ...state, open: false };
  emit();
}

export function useSearchState(): { open: boolean; query: string } {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => state,
    () => state,
  );
}
